import { IIntervention } from "../interfaces/patient/IPatientInterventions"
import { InterventionActionsTypes } from "../constants/actionTypes"
import { isNil } from "lodash"

function init(): IIntervention[] {
	return null
}
export const interventionReducer = function (state = init(), action: any) {
	switch (action.type) {
		case InterventionActionsTypes.UPDATE_PATIENT_INTERVENTION: {
			return isNil(action?.payload) ? null : action?.payload
		}
		case InterventionActionsTypes.DELETE_PATIENT_INTERVENTION: {
			return init()
		}
		default:
			return state
	}
}
